export default "__VITE_ASSET__ERAk06wK__"